<template>
  <div class="permissions-page">
    <div class="header">
      <h2>🔒 Role Permissions Management</h2>
      <router-link to="/system_roles" class="btn-back"
        >← Back to Roles</router-link
      >
    </div>

    <div class="role-info">
      <p><strong>Role Name:</strong> {{ role.name }}</p>
      <p><strong>Role ID:</strong> {{ role.id }}</p>
    </div>

    <table class="permissions-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Permission</th>
          <th>Description</th>
          <th>Has Permission</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="permission in systemPermissions" :key="permission.id">
          <td>{{ permission.id }}</td>
          <td>{{ permission.name }}</td>
          <td>{{ permission.description }}</td>
          <td>
            <input
              type="checkbox"
              v-model="assignedPermissions"
              :value="permission.id"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <button class="btn-save" @click="saveChanges">💾 Save Changes</button>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "RolePermissions",
  data() {
    return {
      role: {
        id: "",
        name: "",
      },
      // System-wide available permissions
      systemPermissions: [],
      // List of permission IDs currently assigned to this role
      assignedPermissions: [], // for example, Nurse currently has Access Reports and Update Vitals
    };
  },
  methods: {
    async saveChanges() {
      try {
        const url = "roles/update-permissions"; // Adjust this endpoint as per your backend
        const body = {
          role_id: this.$route.params.roleID,
          permission_ids: this.assignedPermissions,
        };

        const res = await generalApiRequest(url, "POST", body, 1);

        if (res.success) {
          alert(
            `✅ Permissions for ${this.role.name} have been updated successfully.`
          );
        } else {
          alert("⚠️ Failed to update permissions. Please try again.");
        }
      } catch (error) {
        console.error("Error updating permissions:", error);
        alert("❌ An error occurred while saving changes.");
      }
    },

    async get_all_data() {
      const url =
        "get_all_package_permissions/for_role/" + this.$route.params.roleID;
      const body = {};
      const rs = await generalApiRequest(url, "GET", body, 1);
      console.log(rs);

      this.systemPermissions = rs.package_permissions;
      this.assignedPermissions = rs.assigned_permissions;
      var role = {
        id: rs.role_id,
        name: rs.role_name,
      };
      this.role = role;
    },
  },
  mounted() {
    this.get_all_data();
  },
};
</script>

<style scoped>
.permissions-page {
  padding: 1.5rem;
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.2rem;
}

.header h2 {
  font-size: 1.4rem;
}

.btn-back {
  background: #2786f7;
  color: #fff;
  padding: 0.45rem 0.8rem;
  text-decoration: none;
  border-radius: 0.3rem;
  font-size: 0.85rem;
}

.role-info {
  margin-bottom: 1rem;
  padding: 0.7rem;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 0.3rem;
}

.permissions-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.permissions-table th,
.permissions-table td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
  font-size: 0.95rem;
}

.permissions-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.permissions-table tr:nth-child(even) {
  background: #fafafa;
}

.btn-save {
  background: #1e7c1e;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.3rem;
  font-size: 0.9rem;
  cursor: pointer;
}
</style>
